import { render, staticRenderFns } from "./KYCIdDocumentProofDialog.vue?vue&type=template&id=7983ccdb&scoped=true&"
import script from "./KYCIdDocumentProofDialog.vue?vue&type=script&lang=js&"
export * from "./KYCIdDocumentProofDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=7983ccdb&scoped=true&lang=css&"
import style1 from "./KYCIdDocumentProofDialog.vue?vue&type=style&index=1&id=7983ccdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7983ccdb",
  null
  
)

export default component.exports